import { AxiosAgentBuilder, IApiClientConfiguration, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  AppointmentResource,
  AppointmentTypeResource,
  CaseFormResource,
  CaseLetterResource,
  CaseResource,
  CaseStatusResource,
  CaseTagResource,
  CaseTypeObjectLinkResource,
  CaseTypeResource,
  CaseTypeTagResource,
  EngageMetricsResource,
  FormContentResource,
  FormResource,
  LetterResource,
  PublicResource,
  TranslationResource,
} from './resources'
import { NylasAdminGrantResource } from './resources/NylasAdminGrantResource'
import { NylasAuthResource } from './resources/NylasAuthResource'
import { NylasOrganizationGrantResource } from './resources/NylasOrganizationGrantResource'

export class EngageClient {
  public readonly appointments: AppointmentResource
  public readonly appointmentTypes: AppointmentTypeResource
  public readonly caseForms: CaseFormResource
  public readonly caseLetters: CaseLetterResource
  public readonly cases: CaseResource
  public readonly caseStatuses: CaseStatusResource
  public readonly caseTags: CaseTagResource
  public readonly caseTypeObjectLinks: CaseTypeObjectLinkResource
  public readonly caseTypes: CaseTypeResource
  public readonly caseTypeTags: CaseTypeTagResource
  public readonly metrics: EngageMetricsResource
  public readonly formContents: FormContentResource
  public readonly forms: FormResource
  public readonly letters: LetterResource
  public readonly nylasAdminGrants: NylasAdminGrantResource
  public readonly nylasAuth: NylasAuthResource
  public readonly nylasOrganizationGrants: NylasOrganizationGrantResource
  public readonly public: PublicResource
  public readonly translation: TranslationResource

  constructor(agent: IHttpAgent) {
    this.appointments = new AppointmentResource(agent)
    this.appointmentTypes = new AppointmentTypeResource(agent)
    this.caseForms = new CaseFormResource(agent)
    this.caseLetters = new CaseLetterResource(agent)
    this.cases = new CaseResource(agent)
    this.caseStatuses = new CaseStatusResource(agent)
    this.caseTags = new CaseTagResource(agent)
    this.caseTypeObjectLinks = new CaseTypeObjectLinkResource(agent)
    this.caseTypes = new CaseTypeResource(agent)
    this.caseTypeTags = new CaseTypeTagResource(agent)
    this.metrics = new EngageMetricsResource(agent)
    this.formContents = new FormContentResource(agent)
    this.forms = new FormResource(agent)
    this.letters = new LetterResource(agent)
    this.nylasAdminGrants = new NylasAdminGrantResource(agent)
    this.nylasAuth = new NylasAuthResource(agent)
    this.nylasOrganizationGrants = new NylasOrganizationGrantResource(agent)
    this.public = new PublicResource(agent)
    this.translation = new TranslationResource(agent)
  }

  public static build(configuration: IApiClientConfiguration): EngageClient {
    return new EngageClient(AxiosAgentBuilder.build(configuration))
  }
}
